import { dateISO } from '../../common/dates';

let apiUrl = 'https://ntb-api.liveblog.pro/api';

export let fetchFeed = async (channel, url) => {
  let res;
  if (url) {
    res = await fetch(`${apiUrl}/${url}`);
  } else {
    res = await fetch(`${apiUrl}/client_blogs/${channel}/posts`);
  }
  if (!res.ok) {
    const message = `En feil oppstod i NTB Live feed: ${res.status}`;
    throw new Error(message);
  }
  return await res.json();
};

export let fetchNewestFeed = async (channel, date) => {
  const source = `{"query":{"filtered":{"filter":{"and":[{"range":{"_updated":{"gt":"${dateISO(
    date
  )}"}}},{"terms":{"post_status":["open","submitted"]}}]}}},"sort":[{"published_date":{"order":"desc","missing":"_last","unmapped_type":"long"}}],"post_filter":{}}`;
  const res = await fetch(
    `${apiUrl}/client_blogs/${channel}/posts?max_results=100&source=${encodeURI(
      source
    )}`
  );
  if (!res.ok) {
    const message = `En feil oppstod i NTB Live feed: ${res.status}`;
    throw new Error(message);
  }
  return await res.json();
};
